import React, { useState } from 'react';
import type { NotebookItemModel } from '../../type/notebook';
import ConfirmDialog from '../../modal/confirmDialog/confirmDialog';
import EditButton from '../../components/editButton/editButton';
import DeleteButton from '../../components/deleteButton/deleteButton';
import './notebookItem.scss';

const NotebookItem: React.FC<NotebookItemModel> = ({ notebook, user, onEdit, onDelete }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit(notebook);
  };

  const handleDeleteClick = () => {
    setShowConfirmDialog(true);
  };  

  const handleConfirmDelete = async () => {
    setShowConfirmDialog(false);
    await onDelete(notebook);
  };    

  return (
    <div className="notebook-item">
      <div className="notebook-item__header">
        <div className="notebook-item__title-section">
          <h5 className="notebook-item__title">{notebook.name}</h5>
        </div>

        {user.iduser === notebook.iduser && (
          <div className="notebook-item__actions">
            {notebook.isPublic && (
              <span className="badge bg-info ms-2" title="Public">
                <i className="bi bi-globe"></i> <span className="badge-text-public">Public</span>
              </span>
            )}            
            <EditButton
              className="btn text-warning"
              onClick={handleEdit}
            />
            <DeleteButton
              className="btn text-danger"
              onClick={handleDeleteClick}
            />
          </div>
        )}
      </div>

      <div className="notebook-item__content">
        {notebook.note}
      </div>

      <ConfirmDialog
        isOpen={showConfirmDialog}
        message={`Are you sure you want to delete "${notebook.name}"?`}
        title="Confirm Deletion"
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowConfirmDialog(false)}
      />  
    </div>
  );
};

export default NotebookItem;